/**
 * FormFieldType
 */
export enum FormFieldType {
    Email = 'email',
    Text = 'text',
}
